if (!customElements.get('lw-search-pager')) {
 customElements.define('lw-search-pager', class extends HTMLElement {
  connectedCallback() {
   this.events?.abort();
   this.events = new AbortController();
   this.seen = new Set();
   this.paused = false;
   this.busy = false;
   const signal = this.events.signal;
   this.addEventListener('click', event => {
    const link = event.target.closest('[data-nlc-next]');
    if (!link || this.paused || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault();
    this.load();
   }, {signal});
   const cancel = event => {
    if (!event.target.closest('form[is="facet-form"], [is="facet-short"], [is="facet-remove"]')) return;
    this.paused = true;
    this.request?.abort();
    this.observer?.disconnect();
   };
   document.addEventListener('submit', event => {
    if (event.target.closest('.template-search')) { this.paused = true; this.request?.abort(); this.observer?.disconnect(); }
   }, {capture:true,signal});
   document.addEventListener('input', cancel, {capture:true,signal});
   document.addEventListener('change', cancel, {capture:true,signal});
   document.addEventListener('click', event => {
    if (event.target.closest('[is="facet-remove"]')) cancel(event);
   }, {capture:true,signal});
   window.addEventListener('popstate', () => { this.paused = true; this.request?.abort(); this.observer?.disconnect(); }, {signal});
   if (this.dataset.mode === 'infinite' && 'IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries => {
     if (entries.some(entry => entry.isIntersecting)) this.load();
    }, {rootMargin:'250px'});
    this.observer.observe(this);
   }
  }
  disconnectedCallback() {
   this.events?.abort();this.request?.abort();this.observer?.disconnect();
  }
  async load() {
   const link = this.querySelector('[data-nlc-next]');
   if (!link || this.busy || this.paused || !this.isConnected) return;
   const url = new URL(link.href, location.href);
   if (url.origin !== location.origin || this.seen.has(url.href)) return;
   const pageKey = url.href;
   const locationKey = location.pathname + location.search;
   const root = this.closest('.shopify-section');
   const list = root?.querySelector('#ProductsList');
   if (!list) return;
   this.busy = true;
   this.setAttribute('aria-busy','true');
   this.observer?.unobserve(this);
   const status = this.querySelector('[role="status"]');
   status.textContent = 'Loading more resultsâ€¦';
   this.request = new AbortController();
   const timeout = setTimeout(() => this.request?.abort(),20000);
   url.searchParams.set('section_id',this.dataset.section);
   try {
    const response = await fetch(url, {signal:this.request.signal});
    if (!response.ok) throw new Error('Page request failed');
    const html = new DOMParser().parseFromString(await response.text(),'text/html');
    const source = html.getElementById(root.id);
    const nextList = source?.querySelector('#ProductsList');
    if (!nextList) throw new Error('Product grid missing');
    if (!this.isConnected || this.paused || locationKey !== location.pathname + location.search || root.querySelector('#ProductsList') !== list) return;
    const existing = new Set([...list.querySelectorAll('[data-nlc-product]')].map(item => item.dataset.nlcProduct));
    let added = 0;
    [...nextList.children].forEach(item => {
     if (item.dataset.nlcProduct && existing.has(item.dataset.nlcProduct)) return;
     if (item.dataset.nlcProduct) {existing.add(item.dataset.nlcProduct);added++;}
     list.append(item);
    });
    this.seen.add(pageKey);
    const nextPager = source.querySelector('lw-search-pager');
    const nav = this.querySelector('nav');
    nav.replaceChildren(...(nextPager ? [...nextPager.querySelector('nav').childNodes] : []));
    status.textContent = this.querySelector('[data-nlc-next]') ? `${added} more results loaded.` : 'All results loaded.';
    if (typeof list.reShowVisibleGridItems === 'function') list.reShowVisibleGridItems();
    if (this.querySelector('[data-nlc-next]')) this.observer?.observe(this);
   } catch (error) {
    if (this.isConnected && !this.paused) {
     status.textContent = 'Could not load more results. Select the button to retry, or open its link in a new tab.';
    }
   } finally {
    clearTimeout(timeout);this.busy = false;this.removeAttribute('aria-busy');
   }
  }
 });
}
